import React, { Component } from 'react'
import Loader from "../../../components/elements/loader/Loader";
import MaterialIcon, { colorPalette } from 'material-icons-react';
import Rank from 'constants/Rank';
import HttpClient from "../../../utils/HttpClient/HttpClient";
import API_URL from "../../../utils/HttpClient/apiRest";
import TreeFormContent from "./TreeFormContent";

export default class TreeFormMobile extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() { }

    render() {
        console.log(this.props.overlayClass)
        return (
            <div className="mobile-tree-form">
                <div className={`footer-container ${this.props.containerClass}`}>

                    <div className={`w-100 absolute vh-100 tree-overlay ${this.props.overlayClass} `}
                        onClick={() => this.props.onOpenClick()} />

                    <div className="tree-form-width">
                        <div className={`tree-form so-shadow ${this.props.openClass}`}>
                            <div className="tree-form-inside-l-1 w-100">
                                <button type="button" onClick={() => this.props.onOpenClick()}
                                    className={`btn rounded-circle open-btn ${this.props.pulseClass}`}>
                                    <MaterialIcon size="25px" color="white" icon={this.props.btnIcon} />
                                </button>
                            </div>

                            <TreeFormContent
                                loaded={this.props.loaded}
                                loading={this.props.loading}
                                interestedListOnly={this.props.interestedListOnly}
                                selectedUser={this.props.selectedUser}
                                empty={this.props.empty}
                                details={this.props.details} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Tree/TreeForm/TreeFormMobile.jsx